<template>
  <v-app class="app" :style="{ backgroundColor: theme.backgroundColor }">
    <v-main class="main">
      <v-app-bar
        dense
        app
        color="primary"
        :dark="!theme.dark"
        class="d-flex justify-center"
        style="text-align:center;"
      >
        {{ title }}
      </v-app-bar>
      <Welcome v-if="mode === 'welcome'" @continue="onWelcome"></Welcome>
      <Agreement v-if="mode === 'agreement'" @agreed="onAgreement"></Agreement>
      <Phone v-if="mode === 'phone'" @phone="onPhone"></Phone>
      <div v-if="mode === 'loading'" class="progress">
        <v-progress-circular indeterminate color="primary"> </v-progress-circular>
      </div>
      <Complete v-if="mode === 'complete'"></Complete>
      <EnrollError v-if="mode === 'error'"></EnrollError>
      <div class="fineprint">
        <a href="/support/" target="_blank">support</a><br />
        <a href="/terms/" target="_blank">terms &amp; conditions</a><br />
        <a href="/privacy/" target="_blank">privacy policy</a>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import vuetify from './plugins/vuetify';
import Welcome from './components/Welcome.vue';
import Agreement from './components/Agreement.vue';
import Phone from './components/Phone.vue';
import Complete from './components/Complete.vue';
import EnrollError from './components/EnrollError.vue';

export default {
  name: 'App',
  components: {
    Welcome,
    Agreement,
    Phone,
    Complete,
    EnrollError,
  },
  computed: {
    ...mapState(['mode', 'theme', 'title']),
  },
  created() {
    this.$store.dispatch('loadStudy');
  },
  methods: {
    onWelcome() {
      this.$store.dispatch('changeMode', 'agreement');
      window.scrollTo(0, 0);
    },
    onAgreement() {
      this.$store.dispatch('changeMode', 'phone');
      window.scrollTo(0, 0);
    },
    onPhone(phoneNumber) {
      this.$store.dispatch('changeMode', 'loading');
      this.$store.dispatch('enroll', phoneNumber);
      window.scrollTo(0, 0);
    },
  },
  watch: {
    theme(val) {
      document.body.style.backgroundColor = val.backgroundColor;
      if (val.dark) {
        vuetify.framework.theme.themes.dark.primary = val.primaryColor;
        vuetify.framework.theme.themes.dark.secondary = val.secondaryColor;
        vuetify.framework.theme.themes.dark.accent = val.accentColor;
        vuetify.framework.theme.themes.dark.error = val.errorColor;
        vuetify.framework.theme.themes.dark.info = val.infoColor;
        vuetify.framework.theme.themes.dark.success = val.successColor;
        vuetify.framework.theme.themes.dark.warning = val.warningColor;
      } else {
        vuetify.framework.theme.themes.light.primary = val.primaryColor;
        vuetify.framework.theme.themes.light.secondary = val.secondaryColor;
        vuetify.framework.theme.themes.light.accent = val.accentColor;
        vuetify.framework.theme.themes.light.error = val.errorColor;
        vuetify.framework.theme.themes.light.info = val.infoColor;
        vuetify.framework.theme.themes.light.success = val.successColor;
        vuetify.framework.theme.themes.light.warning = val.warningColor;
      }
    },
  },
};
</script>

<style lang="scss">
@import './styles/_variables.scss';
html {
  box-sizing: border-box;
  width: 100vw;
  height: -webkit-fill-available;
  margin: 0px;
  padding: 0px;
}

body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  margin: 0px;
  padding: 0px;
}

.app {
  align-self: center;
  width: 100vw;
  max-width: 768px;

  .progress {
    width: 32px;
    height: 32px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5rem;
  }

  .v-application--wrap {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  .main {
    width: 100%;
  }

  .fineprint {
    font-size: 10px;
    line-height: 11px;
    margin-top: -53px;
    margin-left: 20px;
    color: #ccc;
    a {
      color: #ccc;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}

@media (min-width: $breakpoint-tablet) {
  .app {
    .fineprint {
      position: fixed;
      bottom: 10px;
      left: 10px;
      margin-top: 0px;
    }
  }
}
</style>
